import React from 'react';
import { GenericFilterHeader } from '../../../components/requests/components/filter-columns/GenericFilterHeader';
import { PropagationStopper } from '../../../components/common';
import { SURVEY_TYPE_FILTER_OPTIONS } from '../surveyTableFilters';

interface SurveyTypeHeaderProps {
    readonly currentValue: string[] | null;
    readonly onChange: (value: string[] | null) => void;
}

export function SurveyTypeHeader({
    currentValue,
    onChange,
}: SurveyTypeHeaderProps) {
    return (
        <PropagationStopper>
            <GenericFilterHeader
                label="Survey"
                filterOptions={SURVEY_TYPE_FILTER_OPTIONS}
                currentValue={currentValue}
                onChange={onChange}
            />
        </PropagationStopper>
    );
}
